module.exports = JSON.parse('{"languageSwitcher":{"label":"Мова"},"close":"Закрыць","pageTitle":"Новы год 2027 — Нічога лішняга! | NL International"}')